import { DOMINATRIX_VISUAL_STYLE_OPTIONS } from '@/pages/Onboarding/options/DominatrixVisualStyle/DOMINATRIX_VISUAL_STYLE_OPTIONS';
import { DominatrixVisualStyleOptionIdType } from '@/pages/Onboarding/options/DominatrixVisualStyle/types';

const DEFAULT_ID: DominatrixVisualStyleOptionIdType = 'latex';
const DEFAULT_TITLE = DOMINATRIX_VISUAL_STYLE_OPTIONS[0].title;

export const getDominatrixVisualStyleIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): DominatrixVisualStyleOptionIdType | null => {
  const id = DOMINATRIX_VISUAL_STYLE_OPTIONS.find(
    (option) => option.title === title,
  )?.id;

  if (id) {
    return id;
  }

  if (withDefault) {
    return DEFAULT_ID;
  }

  return null;
};

export const getDominatrixVisualStyleTitleById = (
  id: DominatrixVisualStyleOptionIdType | null | undefined,
  withDefault = false,
): string | null => {
  const title = DOMINATRIX_VISUAL_STYLE_OPTIONS.find(
    (option) => option.id === id,
  )?.title;

  if (title) {
    return title;
  }

  if (withDefault) {
    return DEFAULT_TITLE;
  }

  return null;
};
